import React from 'react';
import Stat from '../Stat';
import styles from './styles.scss';

var Stats = function Stats(props) {
  var children = props.children,
      listClassName = props.listClassName;
  return /*#__PURE__*/React.createElement("ul", {
    className: "".concat(styles.listStats, " ").concat(listClassName || '')
  }, React.Children.map(children, function (child) {
    return child && /*#__PURE__*/React.createElement("li", {
      key: child.label
    }, child) || '';
  }));
};

Stats.defaultProps = {
  listClassName: null
};
export default Stats;